import { TimelineElement, TimelineElementHttp } from '../models/timeline.model';
import { timestampToDate } from './date.helper';

export function timelineElementHttpToTimelineElement(element: TimelineElementHttp): TimelineElement {
  return {
    ...element,
    created_at: timestampToDate(element.created_at),
    updated_at: timestampToDate(element.updated_at)
  };
}
